import React from 'react';
/**
 * Stores the modal's close handler for any children that might need it.
 */ const ModalCloseContext = /*#__PURE__*/ React.createContext(()=>null);
export default ModalCloseContext;

//# sourceMappingURL=context.js.map